import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { AccountingRange } from 'src/features/accountingRanges/utils/types';
import { AccountingRangeFormSchemaValues } from 'src/features/accountingRanges/utils/formSchema';

const RESOURCE = '/financial-documents/accounting-range/:id/';

type MutationFnType = typeof mutationFn;

interface DTO extends AccountingRangeFormSchemaValues {
    id: string;
}
const mutationFn = ({ id, ...data }: DTO): Promise<AccountingRange> => {
    return axios.put(formatResourcePath(RESOURCE, { id }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateAccountingRange };
